module.exports = __webpack_public_path__ + "static/media/liberty.441836d5.png";